
<template>
    <div id="followc" class="wrapperc">
       hello
       <div class="foo">
            <div class="left">

            </div>
            <div class="right">

            </div>

       </div>

        <div v-for="(value, key, index) in settings.products" :key="key" :index="index">
            <p>{{ value.id }}</p>
            <div v-if="value.settings">
                <div v-for="(value2, key2) in value.settings" :key="key2">
                    <p>- {{ value2.id }}</p>
                     <div v-if="value2.collection">
                        <p>---------</p>
                        <div v-for="(value3, key3) in value2.collection" :key="key3">
                            <p>- {{ value3.id }}</p>

                            <div v-if="value3.collection">
                                <div v-for="(value4, key4) in value3.collection" :key="key4">
                                    <p>--- {{ value4.id }}</p>

                                    <div v-if="value4.collection">has collection</div>
                                     <div v-if="value4.settings">
                                        <p>------- [has settings]</p>
                                         <div v-for="(settings, settingsKey) in value4.settings" :key="settingsKey">
                                            <p>------- {{ settings.id }} - {{ settings.type }}</p>

                                            <div v-if="settings.type === 'reflux'">I am reflux</div> 
                                         </div>
                                     </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>

    
                <!-- <div>Key: {{ key }}, Value: {{ value }}, Index: {{ index }}</div>
                <div v-for="(c, k) in value" :key="k">--- cKey: {{ k }} | cVal: {{ c }}</div> -->
             


        <!-- <div v-for="(value, key, index) in colors.core" :key="key" >
                <div>Key: {{ key }}, Value: {{ value }}, Index: {{ index }}</div>
                <div v-for="(c, k) in value" :key="k">--- cKey: {{ k }} | cVal: {{ c }}</div>
              </div> -->
    </div>

  </template>

  
  <script>
  /* eslint-disable */
 // eslint-disable-next-line no-unused-vars
  import colorJSON from '@/json/colors.json';
  import settingsJSON from '@/json/settings.json';
// import axios from 'axios';
// import Display from './Display.vue';
// import HelperIcons from '@/components/HelperIcons.vue';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

// import ActiveDemoTic from './ActiveDemoTic.vue';


export default {
  name: 'SettingsDemo',
  components: {
   // ActiveDemoTic
    // Display
    // HelperIcons
    // SvgHelper
    // HelloWorld
  },
  data(){
    return{
        colors: colorJSON,
        settings: settingsJSON

    
      
    }
  },
  mounted() {
  
  },
  unmounted() {

  },
  computed:{
   
    
  },
  methods: {}
    
}
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    // @import "styles/compass.scss";


.foo {
    height: 100px;
    display: flex;
    gap: 10px;
    .left {background-color: aqua; height: auto; width:100%;}
    .right {background-color: bisque; height: auto;width:100%;}
}


p {user-select: none; }

  .circ {
    width:30px;
    height:30px;
    background-color: red;
    position: fixed;
  }



  </style>
  